import WidgetUtil from "../utils/WidgetUtil.js";
WidgetUtil.mountWidgets();